import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Building2 } from "lucide-react";
import { Footer } from "../components/Footer";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8cb5d32c-b1ce-4951-b77e-897f98e6cc9f/artifacts/uyctypm7_41ed1e03-8bc9-42a0-8314-b43b52fec9a9.JPG";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact - Afro Fanthem";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Afro Fanthem" className="h-10 w-auto" />
            </Link>
            <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-testid="back-home-link">
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      <main className="pt-24 pb-16 px-4">
        <article className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl sm:text-5xl text-white uppercase tracking-tight mb-4" data-testid="contact-headline">
            Contact <span className="text-[#FBBF24]">Us</span>
          </h1>
          <p className="text-gray-300 text-lg leading-relaxed mb-10">
            Whether you are a fan, a club, a media partner, or a brand interested in African football, we would like to hear from you.
          </p>

          <div className="grid sm:grid-cols-2 gap-6 mb-12">
            <div className="bg-white/5 border border-white/10 p-8">
              <div className="w-14 h-14 bg-[#FBBF24]/10 flex items-center justify-center mb-6">
                <Mail className="w-7 h-7 text-[#FBBF24]" />
              </div>
              <h2 className="font-heading text-xl text-white uppercase mb-3">Afro Fanthem Enquiries</h2>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                General questions about the project, the survey, partnerships, or fan community.
              </p>
              <a href="mailto:afrofanthem@afrofanthem.com" className="text-[#FBBF24] hover:underline font-medium" data-testid="contact-email-afrofanthem">
                afrofanthem@afrofanthem.com
              </a>
            </div>

            <div className="bg-white/5 border border-white/10 p-8">
              <div className="w-14 h-14 bg-[#FBBF24]/10 flex items-center justify-center mb-6">
                <Building2 className="w-7 h-7 text-[#FBBF24]" />
              </div>
              <h2 className="font-heading text-xl text-white uppercase mb-3">Company / Admin Enquiries</h2>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                Business, legal, or administrative matters related to Southern African Traders Ltd.
              </p>
              <a href="mailto:admin@satraders.co.uk" className="text-[#FBBF24] hover:underline font-medium" data-testid="contact-email-admin">
                admin@satraders.co.uk
              </a>
            </div>
          </div>

          <div className="bg-[#141414] border border-white/10 p-8 text-center">
            <h2 className="font-heading text-2xl text-white uppercase mb-4">Follow the Movement</h2>
            <p className="text-gray-400 mb-6">Stay connected through our social channels for updates, music, and community news.</p>
            <div className="flex justify-center gap-4 flex-wrap">
              <a href="https://www.instagram.com/afrofanthem/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors text-sm font-medium">Instagram</a>
              <span className="text-gray-600">|</span>
              <a href="https://www.youtube.com/@AfroFanthem" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors text-sm font-medium">YouTube</a>
              <span className="text-gray-600">|</span>
              <a href="https://x.com/Afrofanthem" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm font-medium">X (Twitter)</a>
              <span className="text-gray-600">|</span>
              <a href="https://www.tiktok.com/@afrofanthem" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm font-medium">TikTok</a>
              <span className="text-gray-600">|</span>
              <a href="https://open.spotify.com/artist/2p4fVYvsZF323pRXdhUEDC" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-500 transition-colors text-sm font-medium">Spotify</a>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10">
            <Link to="/" className="inline-flex items-center gap-2 text-[#FBBF24] font-bold uppercase tracking-widest hover:gap-4 transition-all" data-testid="contact-back-link">
              <ArrowLeft className="w-5 h-5" />
              Back to Homepage
            </Link>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}
